<template>
  <svg viewBox="0 0 20 20" class="icon" aria-labelledby="icon-watch" role="img">
    <title id="icon-watch"><slot></slot></title>
    <path
      id="eye-whites"
      d="M10,16 C5.03,16 1,10 1,10 C1,10 5.03,5 10,5 C14.97,5 19,10 19,10 C19,10 14.97,16 10,16 Z"
    />
    <path
      id="eye-shape"
      d="M10,16 C5.03,16 1,10 1,10 C1,10 5.03,5 10,5 C14.97,5 19,10 19,10 C19,10 14.97,16 10,16 Z M4.55,8.69 C3.98762826,9.12196543 3.45415308,9.59030118 2.953,10.092 C3.47733597,10.7321746 4.04536049,11.335283 4.653,11.897 C6.436,13.54 8.272,14.5 10,14.5 C11.727,14.5 13.563,13.54 15.348,11.897 C15.9552954,11.3352487 16.522985,10.7321411 17.047,10.092 C16.5459392,9.5905796 16.0128153,9.12225898 15.451,8.69 C13.653,7.31 11.79,6.5 10,6.5 C8.208,6.5 6.347,7.31 4.55,8.69 Z"
    />
    <circle id="eye-iris" cx="10" cy="9.5" r="3.5" />
    <path
      id="eye-lid"
      d="M10,6 C5.03,6 1,10 1,10 C1,10 5.03,5 10,5 C14.97,5 19,10 19,10 C19,10 14.97,6 10,6 Z"
      data-alt-d="M10,15.4253906 C5.03,15.4253906 1,10 1,10 C1,10 5.03,5 10,5 C14.97,5 19,10 19,10 C19,10 14.97,15.4253906 10,15.4253906 Z"
    />
  </svg>
</template>

<script>
import anime from "animejs";

export default {
  data() {
    return {
      timeline: anime.timeline({
        autoplay: false,
        direction: "normal",
        easing: "easeInOutCirc",
        loop: true
      })
    };
  },

  props: {
    animate: Boolean
  },

  computed: {
    eyelidPaths: function() {
      const eyelid = this.$el.querySelector("#eye-lid");

      return {
        open: eyelid.getAttribute("d"),
        closed: eyelid.getAttribute("data-alt-d")
      };
    }
  },

  watch: {
    animate: function(val) {
      if (val == true) {
        this.timeline.play();
      } else {
        this.timeline.restart();
        this.timeline.pause();
      }
    }
  },

  mounted: function() {
    const { open, closed } = this.eyelidPaths;

    this.timeline
      .add({
        targets: "#eye-whites",
        opacity: {
          value: 1,
          duration: 3000
        }
      })
      .add(this.lidAnime(closed, 100))
      .add(this.lidAnime(open, 150))
      .add(this.irisAnime(-3, 150))
      .add(this.irisAnime(-3, 750))
      .add(this.irisAnime(3, 200))
      .add(this.irisAnime(3, 750))
      .add(this.irisAnime(0, 250))
      .add(this.irisAnime(0, 3000))
      .add(this.lidAnime(closed, 100))
      .add(this.lidAnime(open, 150));
  },

  methods: {
    lidAnime: function(path, duration) {
      return {
        targets: "#eye-lid",
        d: {
          value: path,
          duration: duration
        }
      };
    },

    irisAnime: function(x, duration) {
      return {
        targets: "#eye-iris",
        translateX: x,
        duration: duration
      };
    }
  }
};
</script>

<style lang="scss">
#eye-whites {
  fill: rgba(white, 0);

  [aria-pressed="true"] & {
    fill: white;
  }
}
</style>
